export default {
    state: {
        progress: 0,
        url: '',
    },
    actions: {
        GET_CONTENT_PROGRESS({ commit, state }, payload) {
            return window.axios
                .get(state.url)
                .then((res) => {
                    commit('SET_PROGRESS', res.data.progress);
                    return res.data.progress;
                })
                .catch(err => console.error(err));
        },
    },
    mutations: {
        SET_PROGRESS_URL(state, payload) {
            state.url = payload;
        },
        SET_PROGRESS(state, payload) {
            state.progress = payload;
        },
    },
    getters: {
        LOADED_PROGRESS(state) {
            return state.progress;
        },
        LOADED_PROGRESS_URL(state) {
            return state.url;
        },
    },
};
